import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrivateLockedIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12.44,17c-.15,0-.29,0-.44,0a5,5,0,1,1,4.36-7.39,4.92,4.92,0,0,1,5.88,4A12.76,12.76,0,0,0,23,12,11.82,11.82,0,0,0,1,12a11.83,11.83,0,0,0,11,7.5l.44,0Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14.54,10.41A3,3,0,1,0,12,15a3.13,3.13,0,0,0,.44,0v-.52A4.92,4.92,0,0,1,14.54,10.41Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M20,16V14.5a2.5,2.5,0,0,0-5,0V16a1.08,1.08,0,0,0-1,1v4a1.08,1.08,0,0,0,1,1h5a1.08,1.08,0,0,0,1-1V17A1.08,1.08,0,0,0,20,16Zm-1,0H16V14.5a1.5,1.5,0,0,1,3,0Z"
  })]
}), 'PrivateLockedIcon');